/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, forwardRef } from "react";
import track, { useTracking } from "react-tracking";
import { SketchPicker, MaterialPicker, SwatchesPicker, BlockPicker } from "react-color";

import axios from "axios";
import * as XLSX from "xlsx";

import { Counter } from "src/components/Testing/Counter/Counter";

// Metrea UI Testing =====================

import {
	Box,
	Button,
	ButtonGroup,
	Checkbox,
	For,
	HStack,
	Icon,
	Input,
	MetreaProvider,
	Stack,
	Steps,
	Text,
	VStack,
} from "@metrea-ui/v2";
import { ArrowRightFilled, MailRegular } from "@fluentui/react-icons";

import { getIndicatorStyle, getTitleStyle, getSeparatorStyle } from "../utils/themeUtils";
import { CheckmarkFilled, AlertBadgeColor, ErrorCircleRegular } from "@fluentui/react-icons";

// Metrea UI Testing =====================

import { Global, css } from "@emotion/react";

import { useDialogBox } from "../hooks/useDialogBox";

import ModalBox from "src/components/UI/Modal/NestedModal";
import ManageChip from "src/components/UI/ConfigsByChips/ManageChip/ManageChip";
import { SortableList } from "src/components/UI/SortableList/SortableList";
import FormMultiSelect from "src/components/UI/common/FormMultiSelect";
import FormTextField from "src/components/UI/common/FormTextField";

import VerticalRangeSlider from "src/components/UI/VerticalSlider/VerticalRangeSlider";
import VerticalSliderInput from "src/components/UI/VerticalSlider/VerticalSliderInput";

import { PageHeader } from "src/components/SiteLayout/Header";
import { PageFooter } from "src/components/SiteLayout/Footer";

import { mColor } from "../utils/themeUtils";
import { Session } from "../utils/sessionUtils";
import { debugLog, errorLog } from "../utils/debugUtils";
import { exportJSON, exportSpreadsheet } from "../utils/fileUtils";
import { sendMail_MS_Graph, sendMail_API } from "../utils/mailUtils";
import { getValuesByPropertyPath } from "../utils/dataUtils";

// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
// import { PDFViewer } from "@react-pdf/renderer";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas-pro";
import ReactToPrint, { useReactToPrint } from "react-to-print";

// import { exportJSON, exportSpreadsheet } from "../js/appLib";
import { InputFileUpload } from "src/components/UI/Upload/InputFileUpload";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	pt: 2,
	px: 4,
	pb: 3,
};

const GlobalStyles = () => (
	<Global
		styles={css`
			* {
				margin: 0;
				padding: 0;
				box-sizing: border-box;
			}
		`}
	/>
);

// SortableList Testing
const items2 = [
	{ id: 1, comp_value: "Gold", color: "Gold", sort_id: 1 },
	{ id: 2, comp_value: "Crimson", color: "Crimson", sort_id: 2 },
	{ id: 3, comp_value: "Hotpink", color: "Hotpink", sort_id: 3 },
	{ id: 4, comp_value: "Blueviolet", color: "Blueviolet", sort_id: 4 },
	{ id: 5, comp_value: "Cornflowerblue", color: "Cornflowerblue", sort_id: 5 },
	{ id: 6, comp_value: "Skyblue", color: "Skyblue", sort_id: 6 },
	{ id: 7, comp_value: "Lightblue", color: "Lightblue", sort_id: 7 },
	{ id: 8, comp_value: "Aquamarine", color: "Aquamarine", sort_id: 8 },
	{ id: 9, comp_value: "Burlywood", color: "Burlywood", sort_id: 9 },
];

// const messageHandler = () => {
// 	setMsgBox(null);
// };

const EmailSender = () => {
	const [toRecipient, setToRecipient] = useState("yle@msim.metrea.aero");
	const [ccRecipient, setCcRecipient] = useState("steady15@gmail.com");
	const [bccRecipient, setBccRecipient] = useState("ylee@crt-i.com");
	const [subject, setSubject] = useState("Email Testing");
	const [body, setBody] = useState("This is Email Testing");

	const renderTextField = (props) => (
		<FormTextField {...props} required size="sm" reserveHelperSpace={false} />
	);

	const handleSend_MS_Graph = async () => {
		// await sendMail_MS_Graph(subject, body, toRecipient, "yle@msim.metrea.aero", "ylee@crt-i.com");
		await sendMail_MS_Graph({
			subject: subject,
			message: body,
			to: toRecipient || ["yle@msim.metrea.aero", "yaofulee@gmail.com"],
			cc: ccRecipient,
			bcc: bccRecipient,
		});
	};

	const handleSend_API = async (event, req) => {
		try {
			await sendMail_API({
				subject: subject || "Email API Testing #1",
				to: toRecipient || ["yle@msim.metrea.aero", "yaofulee@gmail.com"],
				cc: ccRecipient,
				bcc: bccRecipient,
				message: body || "<h1>Hello World</h1>",
			});
			// .then((response) => {
			// 	console.log("sendMail_API response:");
			// 	console.log(response);
			// });
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Box display="flex" w="60%" flexDirection="column">
				<Text textStyle="lg" fontWeight="semibold">
					Email Testing
				</Text>

				{renderTextField({
					id: "toRecipient",
					name: "toRecipient",
					label: "To",
					placeholder: "To Recipient",
					value: toRecipient,
					onChange: (e) => setToRecipient(e.target.value),
				})}
				{renderTextField({
					id: "ccRecipient",
					name: "ccRecipient",
					label: "Cc",
					placeholder: "Cc Recipient",
					value: ccRecipient,
					onChange: (e) => setCcRecipient(e.target.value),
				})}
				{renderTextField({
					id: "bccRecipient",
					name: "bccRecipient",
					label: "Bcc",
					placeholder: "Bcc Recipient",
					value: bccRecipient,
					onChange: (e) => setBccRecipient(e.target.value),
				})}
				{renderTextField({
					id: "Subject",
					name: "Subject",
					label: "Subjects",
					placeholder: "Subject",
					value: subject,
					onChange: (e) => setSubject(e.target.value),
				})}
				{renderTextField({
					id: "emailBody1",
					name: "emailBody",
					label: "Body",
					placeholder: "Body",
					value: body,
					onChange: (e) => setBody(e.target.value),
					multiline: true,
					rows: 6,
				})}
				<br />
				<Button onClick={handleSend_MS_Graph}>Send Email as login user (via MS Graph)</Button>
				<br />
				<Button onClick={handleSend_API}>Send Email as application (via api call)</Button>
			</Box>
		</Box>
	);
};

const MetreaUIv2Button = () => {
	const testingHandler = (event, variant) => {
		alert(`metrea-ui-v2 Button (variant: ${variant}) is clicked!`);
	};

	return (
		<Box style={{ background: "#fafafa", margin: "1rem", padding: "1rem" }}>
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					Metrea UI v2 - Button
				</Text>
				<Text textStyle="md" fontWeight="medium">
					import Button from "@metrea-ui/v2";
				</Text>
				<HStack align="flex-start">
					<Button onClick={(event) => testingHandler(event, "default")}>Button</Button>
				</HStack>
				<HStack align="flex-start" wrap="wrap" gap="12" paddingTop="1rem">
					<For each={["solid", "subtle", "surface", "outline", "ghost", "plain"]}>
						{(variant) => (
							<Button
								key={variant}
								variant={variant}
								onClick={(e) => testingHandler(e, variant)}
							>
								{variant}
							</Button>
						)}
					</For>
				</HStack>
			</Stack>
		</Box>
	);
};

const MetreaUIv2Checkbox = () => {
	const variants = ["outline", "subtle", "solid"];
	const [checkedMap, setCheckedMap] = useState(
		() => Object.fromEntries(variants.map((v) => [v, true])), // initial: all true (like defaultChecked)
	);

	const testingHandler = (event, variant, checked) => {
		alert(`metrea-ui-v2 Checkbox (variant: ${variant}) is ${!checked ? "checked" : "unchecked"}`);
	};

	return (
		<Box style={{ background: "#fafafa", margin: "1rem", padding: "1rem" }}>
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					Metrea UI v2 - Checkbox
				</Text>
				<Text textStyle="md" fontWeight="medium">
					import Checkbox from "@metrea-ui/v2";
				</Text>
				<HStack align="flex-start" gap="12" paddingTop="1rem">
					<For each={variants}>
						{(variant) => (
							<Stack align="flex-start" flex="1" gap="3" key={variant}>
								<Text>{variant}</Text>
								<Checkbox.Root
									// defaultChecked
									variant={variant}
									checked={!!checkedMap[variant]}
									onCheckedChange={(detail) => {
										// metrea-ui-v2 often passes { checked } or boolean; handle both
										const next =
											typeof detail === "object" ? !!detail?.checked : !!detail;
										setCheckedMap((prev) => ({ ...prev, [variant]: next }));
									}}
								>
									<Checkbox.HiddenInput
										onChange={(e) => testingHandler(e, variant, checkedMap[variant])}
									/>
									<Checkbox.Control />
									<Checkbox.Label>Checkbox</Checkbox.Label>
								</Checkbox.Root>
							</Stack>
						)}
					</For>
				</HStack>
			</Stack>
		</Box>
	);
};

const MetreaUIv2CustomizationNote = () => (
	<Box style={{ background: "#fafafa", margin: "1rem", padding: "1rem" }}>
		<Stack>
			<Text textStyle="lg" fontWeight="semibold">
				Metrea UI v2 - App Customization Path
			</Text>
			<Text textStyle="md" fontWeight="medium">
				Use shared Metrea theme and component paths for RAVEN button or input customization work.
			</Text>
			<Text textStyle="sm">
				The older Chakra-based test wrappers were local experiments and are no longer the preferred
				production pattern.
			</Text>
			<Text textStyle="sm">
				Keep test coverage centered on direct `@metrea-ui/v2` usage so this page stays aligned with
				the current app UI stack.
			</Text>
		</Stack>
	</Box>
);

const DirectV2ButtonMatrix = () => {
	const VARIANTS = ["solid", "subtle", "outline", "ghost"];
	const SIZES = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl"];

	const testingHandler = (event, variant, size) => {
		alert(`@metrea-ui/v2 Button (variant: ${variant} | size: ${size}) is clicked!`);
	};

	return (
		<Box style={{ background: "#fafafa", margin: "1rem", padding: "1rem" }}>
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					Button variant matrix (@metrea-ui/v2)
				</Text>
				<Text textStyle="md" fontWeight="medium">
					<br />
					const variants = ["solid", "subtle", "outline", "ghost"];
					<br />
					const sizes = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl"];
					<br />
					colorPalette = ["default", "red", "green"];
				</Text>
				<HStack align="flex-start" wrap="wrap" gap="12" paddingTop="1rem">
					<Stack>
						{VARIANTS.map((variant) => (
							<HStack wrap="wrap" key={variant} alignItems={"start"}>
								{SIZES.map((size) => (
									<Button
										key={`${variant}-${size}`}
										size={size}
										variant={variant}
										onClick={(e) => testingHandler(e, variant, size)}
									>
										<MailRegular />
										Button
										<ArrowRightFilled />
									</Button>
								))}
							</HStack>
						))}
					</Stack>
					<Stack>
						{VARIANTS.map((variant) => (
							<HStack wrap="wrap" key={variant} alignItems={"start"}>
								{SIZES.map((size) => (
									<Button
										key={`${variant}-${size}`}
										size={size}
										variant={variant}
										colorPalette="red"
										onClick={(e) => testingHandler(e, variant, size)}
									>
										<MailRegular />
										Button
										<ArrowRightFilled />
									</Button>
								))}
							</HStack>
						))}
					</Stack>
					<Stack>
						{VARIANTS.map((variant) => (
							<HStack wrap="wrap" key={variant} alignItems={"start"}>
								{SIZES.map((size) => (
									<Button
										key={`${variant}-${size}`}
										size={size}
										variant={variant}
										colorPalette="green"
										onClick={(e) => testingHandler(e, variant, size)}
									>
										<MailRegular />
										Button
										<ArrowRightFilled />
									</Button>
								))}
							</HStack>
						))}
					</Stack>
				</HStack>
			</Stack>
		</Box>
	);
};

// const DirectV2Card = () => {
// 	return (
// 		<>
// 			<Text textStyle="lg" fontWeight="semibold">
// 				Card Testing
// 			</Text>
// 			<Box style={{ background: "lightblue", margin: "1rem", padding: "1rem" }}>
// 				{/* // Simple (title + body) */}
// 				<Card title="Simple (title + body)" variant="outlined" divided>
// 					<ExportTesting />
// 				</Card>

// 				{/* // Composable (header/body/footer like Chakra) */}
// 				<Card variant="elevated" title="Composable (header/body/footer like Chakra)" radius="xl">
// 					<Card.Header divided>
// 						<Text textStyle="md" fontWeight="medium">
// 							Composable (header/body/footer like Chakra)
// 						</Text>
// 					</Card.Header>
// 					<Card.Body>
// 						<ExportTesting />
// 					</Card.Body>
// 					<Card.Footer divided>
// 						<Button>Submit</Button>
// 					</Card.Footer>
// 				</Card>

// 				{/* // One-shot with subheader/footer */}
// 				<Card
// 					title="One-shot with subheader/footer"
// 					subheader="subheader: Based on PB25 budget request"
// 					footer={<Button>Save</Button>}
// 					variant="outlined"
// 					divided
// 				>
// 					<ExportTesting />
// 				</Card>
// 			</Box>
// 		</>
// 	);
// };

const MetreaUIv2Steps = () => {
	// Keep the step index 0-based to match the local test flow state.
	const [activeStep, setActiveStep] = useState(1);
	const [completed, setCompleted] = useState({}); // { [index]: true }

	const steps = [
		{
			title: "Step 1",
			description: "Step 1 description",
		},
		{
			title: "Step 2",
			description: "Step 2 description",
		},
		{
			title: "Step 3",
			description: "Step 3 description",
		},
	];

	// Test-only complete handler; wire real validation/save here if needed.
	const handleComplete = () => {
		// TODO: run your validation here; bail early if invalid
		setCompleted((prev) => ({ ...prev, [activeStep]: true }));
		// Optionally call your save/create here, then move next, etc.
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					Steps Testing
				</Text>
				<Box p="3rem">
					<Steps.Root
						count={steps.length}
						index={activeStep}
						onStepChange={(e) => setActiveStep(e.step)}
					>
						<Steps.List>
							{steps.map((step, index) => {
								const ind = getIndicatorStyle(index, activeStep);
								const title = getTitleStyle(index, activeStep);
								const sep = getSeparatorStyle(index, activeStep);
								const isSaved = !!completed[index];
								const isActive = index === activeStep;

								return (
									<Steps.Item key={index} index={index} title={step.title}>
										<Steps.Trigger onClick={() => setActiveStep(index)}>
											<Steps.Indicator
												bg={ind.bg}
												border={ind.border}
												p={ind.p}
												m={ind.m}
											>
												{/* our custom circle (pure Chakra props) */}
												<Box {...ind.__circle}>
													{isSaved ? (
														<Icon as={CheckmarkFilled} boxSize="1.5rem" />
													) : (
														index + 1
													)}
												</Box>
											</Steps.Indicator>

											<Steps.Title {...title}>{step.title}</Steps.Title>
										</Steps.Trigger>

										<Steps.Separator {...sep} />
									</Steps.Item>
								);
							})}
						</Steps.List>

						{steps.map((step, index) => (
							<Steps.Content key={index} index={index}>
								{step.description}
							</Steps.Content>
						))}
						<Steps.CompletedContent>All steps are complete!</Steps.CompletedContent>

						<Box mt={4}>
							<ButtonGroup size="sm" variant="outline">
								<Button onClick={() => setActiveStep((s) => Math.max(s - 1, 0))}>Prev</Button>
								<Button
									onClick={() => setActiveStep((s) => Math.min(s + 1, steps.length - 1))}
								>
									Next
								</Button>
								<Button onClick={handleComplete}>Save</Button>
							</ButtonGroup>
						</Box>
					</Steps.Root>
				</Box>
			</Stack>
		</Box>
	);
};

const MetreaUiTesting = () => {
	const testingHandler = () => {
		alert("(MetreaUiTesting) Testing is clicked!");
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Text textStyle="lg" fontWeight="semibold">
				Button/Checkbox Testing
			</Text>

			<MetreaUIv2Button />

			<MetreaUIv2Checkbox />

			<MetreaUIv2CustomizationNote />

			<DirectV2ButtonMatrix />

			{/* <DirectV2Card /> */}
		</Box>
	);
};

const PrintToPdfTesting1 = () => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});
	const ComponentToPrint = React.forwardRef((props, ref) => {
		// return <TutorialsList innerRef={ref} />;
		return (
			<div ref={ref}>
				<ExportTesting />
			</div>
		);
	});

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					PrintToPdf Testing1
				</Text>
				<ComponentToPrint ref={componentRef} />
				<Button onClick={handlePrint}>Print this out!</Button>
			</Stack>
		</Box>
	);
};

const PrintToPdfTesting2 = () => {
	const printDocument = () => {
		const input = document.getElementById("divToPrint");
		// html2canvas(input).then((canvas) => {
		// 	const imgData = canvas.toDataURL("image/png");
		// 	const pdf = new jsPDF();
		// 	pdf.addImage(imgData, "JPEG", 0, 0);
		// 	// pdf.output('dataurlnewwindow');
		// 	pdf.save("download.pdf");
		// });

		input.style.backgroundColor = "#eedddd";
		input.style.width = "210mm";
		input.style.minHeight = "297mm";
		// input.style.minHeight= "360mm";
		input.style.marginLeft = "auto";
		input.style.marginRight = "auto";

		html2canvas(input).then((canvas) => {
			const imgData = canvas.toDataURL("image/png");

			/*
      Here are the numbers (paper width and height) that I found to work. 
      It still creates a little overlap part between the pages, but good enough for me.
      if you can find an official number from jsPDF, use them.
      */
			var imgWidth = 210;
			var pageHeight = 295;
			// var pageHeight = 360;
			var imgHeight = (canvas.height * imgWidth) / canvas.width;
			var heightLeft = imgHeight;

			var pdf = new jsPDF("p", "mm");
			var position = 0;

			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;

			while (heightLeft >= 0) {
				position = heightLeft - imgHeight;
				pdf.addPage();
				pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
				heightLeft -= pageHeight;
			}

			// pdf.output('dataurlnewwindow');
			pdf.save("download.pdf");
		});

		input.style.backgroundColor = mColor.White;
		input.style.width = "auto";
		input.style.minHeight = "auto";
		input.style.marginLeft = "auto";
		input.style.marginRight = "auto";
	};

	const downlpadPDF = () => {
		// run on node.js
		// import ReactPDF from '@react-pdf/renderer';
		// ReactPDF.render(<MyDocument />, `${__dirname}/example.pdf`);
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					PrintToPdf Testing2
				</Text>

				<div id="divToPrint">
					{/* <PDFViewer>
								<MyDocument />
							</PDFViewer>
							<ButtonM1 onClick={() => downlpadPDF()}>Download PDF</button> */}

					<Button onClick={() => printDocument()}>Print PDF</Button>
					<div>Note: Here the dimensions of div are same as A4</div>
					<div>You Can add any component here</div>
					<ExportTesting />
				</div>
			</Stack>
		</Box>
	);
};

const SliderTesting = () => {
	const initArrayItems = [
		{
			id: 1,
			comp_id: 11778,
			type: "Near-term",
			value: "-0.1",
		},
		{
			id: 2,
			comp_id: 11778,
			type: "Long-term",
			value: "0.7",
		},
	];
	const props = {
		label: "Great Power Competition",
		range: "normalized",
		extra: {
			id: 11778,
			baseline_id: 165,
			comp_type_id: 121,
			comp_value: "Great Power Competition",
			status_id: 1,
			sort_id: 1,
			photo: {
				type: "Buffer",
				data: [],
			},
			thumbnail: {
				type: "Buffer",
				data: [],
			},
			color: "null",
			createdAt: "2023-11-22T18:47:29.656Z",
			updatedAt: "2023-11-22T18:47:29.656Z",
			createdBy: 1,
			updatedBy: 0,
			scenario_id: 43,
			decimalPoint: 2,
			currencyUnit: "B",
			currencySymbol: "$",
		},
		step: 1,
		mode: "edit",
		scenarioConfigs: [
			{
				id: 547,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 602,
				comp_value1: "-0.3",
				comp_value2: "0.7",
				status_id: 1,
				sort_id: 24,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 537,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 603,
				comp_value1: "-0.6",
				comp_value2: "0.8",
				status_id: 1,
				sort_id: 25,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 540,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 604,
				comp_value1: "-0.3",
				comp_value2: "0.9",
				status_id: 1,
				sort_id: 26,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 534,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11780,
				comp_value1: "0.5",
				comp_value2: "0.4",
				status_id: 1,
				sort_id: 3,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 532,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11781,
				comp_value1: "-0.4",
				comp_value2: "-0.7",
				status_id: 1,
				sort_id: 4,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-03T19:43:56.270Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 531,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11782,
				comp_value1: "-0.1",
				comp_value2: "0.5",
				status_id: 1,
				sort_id: 5,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-02T16:07:01.081Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 544,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11783,
				comp_value1: "-0.3",
				comp_value2: "0.3",
				status_id: 1,
				sort_id: 11,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-04T10:52:02.837Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 541,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11784,
				comp_value1: "-0.4",
				comp_value2: "0.4",
				status_id: 1,
				sort_id: 12,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 546,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11785,
				comp_value1: "-0.5",
				comp_value2: "0.5",
				status_id: 1,
				sort_id: 13,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 549,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11786,
				comp_value1: "-0.6",
				comp_value2: "0.3",
				status_id: 1,
				sort_id: 14,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-03T19:43:56.270Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 542,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11787,
				comp_value1: "-0.7",
				comp_value2: "0.0",
				status_id: 1,
				sort_id: 15,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 536,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11788,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 16,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 538,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11789,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 17,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 535,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11694,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 18,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 545,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11689,
				comp_value1: "-2",
				comp_value2: "0",
				status_id: 1,
				sort_id: 19,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 543,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11690,
				comp_value1: "19",
				comp_value2: "0",
				status_id: 1,
				sort_id: 20,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 539,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11691,
				comp_value1: "-2",
				comp_value2: "0",
				status_id: 1,
				sort_id: 21,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 548,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11692,
				comp_value1: "19",
				comp_value2: "0",
				status_id: 1,
				sort_id: 22,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 550,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11693,
				comp_value1: "-2",
				comp_value2: "0",
				status_id: 1,
				sort_id: 23,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 533,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11779,
				comp_value1: "0.1",
				comp_value2: "0.7",
				status_id: 1,
				sort_id: 2,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-08-13T13:20:47.739Z",
				createdBy: 1,
				updatedBy: 1,
				update_flag: 102,
			},
			{
				id: 530,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11778,
				comp_value1: "-0.1",
				comp_value2: "0.7",
				status_id: 1,
				sort_id: 1,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-08-13T13:20:47.739Z",
				createdBy: 1,
				updatedBy: 1,
				update_flag: 102,
			},
		],
		pref: {
			id: 121,
			type_id: 2,
			group_id: 100,
			code: "operational_preferences",
			name: "Operational Preferences",
			description:
				"List of Operational Preferences (freeform list like the military services, domains, and categories) ",
			flag1: null,
			flag2: 10,
			status_id: 1,
			sort_id: 121,
			z_createdAt: "2023-07-26T18:44:30.827Z",
			z_updatedAt: "2023-07-26T18:44:30.827Z",
			z_comments: null,
			z_internal_notes: null,
			z_createdBy: 0,
			z_updatedBy: 0,
			format: "list",
			createdAt: "2023-07-26T18:44:30.827Z",
			updatedAt: "2023-07-26T18:44:30.827Z",
			comments: null,
			internal_notes: null,
			createdby: 0,
			updatedby: 0,
			items: [
				{
					id: 11778,
					baseline_id: 165,
					comp_type_id: 121,
					comp_value: "Great Power Competition",
					status_id: 1,
					sort_id: 1,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2023-11-22T18:47:29.656Z",
					createdBy: 1,
					updatedBy: 0,
				},
				{
					id: 11779,
					baseline_id: 165,
					comp_type_id: 121,
					comp_value: "Middle Power Competition",
					status_id: 1,
					sort_id: 2,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2023-11-22T18:47:29.656Z",
					createdBy: 1,
					updatedBy: 0,
				},
				{
					id: 11780,
					baseline_id: 165,
					comp_type_id: 121,
					comp_value: "Nuclear Deterrence",
					status_id: 1,
					sort_id: 3,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2023-11-22T18:47:29.656Z",
					createdBy: 1,
					updatedBy: 0,
				},
				{
					id: 11781,
					baseline_id: 165,
					comp_type_id: 121,
					comp_value: "Counter VEO",
					status_id: 1,
					sort_id: 2511,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2023-11-22T18:47:29.656Z",
					createdBy: 1,
					updatedBy: 0,
				},
				{
					id: 11782,
					baseline_id: 165,
					comp_type_id: 121,
					comp_value: "Humanitarian Assistance",
					status_id: 1,
					sort_id: 2512,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2023-11-22T18:47:29.656Z",
					createdBy: 1,
					updatedBy: 0,
				},
			],
		},
	};
	const initThisCfg = {
		id: 530,
		scenario_id: 43,
		comp_type_id: 121,
		comp_id: 11778,
		comp_value1: "-0.1",
		comp_value2: "0.7",
		status_id: 1,
		sort_id: 1,
		photo: null,
		thumbnail: null,
		color: null,
		createdAt: "2025-04-11T13:02:26.402Z",
		updatedAt: "2025-08-13T13:20:47.739Z",
		createdBy: 1,
		updatedBy: 1,
		update_flag: 102,
	};

	const [thisCfg, setThisCfg] = useState(initThisCfg);
	const [arrayItems, setArrayItems] = useState(initArrayItems);

	const getArrayItems = (cfg) => {
		const cfgTypes = ["Near-term", "Long-term"];
		let arrayTemp = [];
		for (let idx = 1; idx <= 2; idx++) {
			if (cfg[`comp_value${idx}`]) {
				arrayTemp.push({
					id: idx,
					comp_id: cfg.comp_id,
					type: cfgTypes[idx - 1],
					value: cfg[`comp_value${idx}`],
				});
			}
		}
		arrayTemp.sort((x, y) => x.value - y.value);
		return arrayTemp;
	};

	const sliderChangeHandler = (items) => {
		items.map((x) => {
			thisCfg[`comp_value${x.id}`] = x.value;
			thisCfg.update_flag = 102;
			return false;
		});
		setThisCfg({ ...thisCfg });
		setArrayItems([...getArrayItems({ ...thisCfg })]);

		debugLog(3, "[Test][ACTION] verticalSliderChangeHandler", {
			props: props,
			items: items,
			thisCfg: thisCfg,
		});
	};

	const initArrayItems2 = [
		{
			id: 1,
			comp_id: 11689,
			value: 7,
		},
	];
	const props2 = {
		label: "FY24",
		range: "perItem",
		extra: {
			id: 11689,
			baseline_id: 165,
			comp_type_id: 11,
			comp_value: "FY24",
			status_id: 1,
			sort_id: 1,
			photo: {
				type: "Buffer",
				data: [],
			},
			thumbnail: {
				type: "Buffer",
				data: [],
			},
			color: "null",
			createdAt: "2023-11-22T18:47:29.656Z",
			updatedAt: "2025-07-18T16:50:11.686Z",
			createdBy: 1,
			updatedBy: 1,
			total_budget_per_year: "11",
			max_budget_increase: "21",
			max_budget_decrease: "31",
			scenario_id: 43,
			decimalPoint: 2,
			currencyUnit: "B",
			currencySymbol: "$",
		},
		step: 1,
		mode: "edit",
		scenarioConfigs: [
			{
				id: 547,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 602,
				comp_value1: "-0.3",
				comp_value2: "0.7",
				status_id: 1,
				sort_id: 24,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 537,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 603,
				comp_value1: "-0.6",
				comp_value2: "0.8",
				status_id: 1,
				sort_id: 25,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 540,
				scenario_id: 43,
				comp_type_id: 21,
				comp_id: 604,
				comp_value1: "-0.3",
				comp_value2: "0.9",
				status_id: 1,
				sort_id: 26,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 530,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11778,
				comp_value1: "-0.1",
				comp_value2: "0.5",
				status_id: 1,
				sort_id: 1,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-08-13T13:20:47.739Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 533,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11779,
				comp_value1: "0.1",
				comp_value2: "0.8",
				status_id: 1,
				sort_id: 2,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-08-13T13:20:47.739Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 534,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11780,
				comp_value1: "0.5",
				comp_value2: "0.4",
				status_id: 1,
				sort_id: 3,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 532,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11781,
				comp_value1: "-0.4",
				comp_value2: "-0.7",
				status_id: 1,
				sort_id: 4,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-03T19:43:56.270Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 531,
				scenario_id: 43,
				comp_type_id: 121,
				comp_id: 11782,
				comp_value1: "-0.1",
				comp_value2: "0.5",
				status_id: 1,
				sort_id: 5,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:02:26.402Z",
				updatedAt: "2025-07-02T16:07:01.081Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 544,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11783,
				comp_value1: "-0.3",
				comp_value2: "0.3",
				status_id: 1,
				sort_id: 11,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-04T10:52:02.837Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 541,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11784,
				comp_value1: "-0.4",
				comp_value2: "0.4",
				status_id: 1,
				sort_id: 12,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 546,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11785,
				comp_value1: "-0.5",
				comp_value2: "0.5",
				status_id: 1,
				sort_id: 13,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-09T20:03:56.160Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 549,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11786,
				comp_value1: "-0.6",
				comp_value2: "0.3",
				status_id: 1,
				sort_id: 14,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-03T19:43:56.270Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 542,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11787,
				comp_value1: "-0.7",
				comp_value2: "0.0",
				status_id: 1,
				sort_id: 15,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-07-02T16:11:54.266Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 536,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11788,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 16,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 538,
				scenario_id: 43,
				comp_type_id: 122,
				comp_id: 11789,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 17,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 535,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11694,
				comp_value1: "0",
				comp_value2: "0",
				status_id: 1,
				sort_id: 18,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-11T13:06:34.824Z",
				createdBy: 1,
				updatedBy: 0,
			},
			{
				id: 543,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11690,
				comp_value1: "19",
				comp_value2: "0",
				status_id: 1,
				sort_id: 20,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 539,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11691,
				comp_value1: "-2",
				comp_value2: "0",
				status_id: 1,
				sort_id: 21,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 548,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11692,
				comp_value1: "19",
				comp_value2: "0",
				status_id: 1,
				sort_id: 22,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 550,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11693,
				comp_value1: "-2",
				comp_value2: "0",
				status_id: 1,
				sort_id: 23,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
			},
			{
				id: 545,
				scenario_id: 43,
				comp_type_id: 611,
				comp_id: 11689,
				comp_value1: 7,
				comp_value2: "0",
				status_id: 1,
				sort_id: 19,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2025-04-11T13:06:34.824Z",
				updatedAt: "2025-04-28T16:50:38.462Z",
				createdBy: 1,
				updatedBy: 1,
				update_flag: 102,
			},
		],
		pref: {
			id: 611,
			type_id: 2,
			group_id: 600,
			code: null,
			name: "Budget Preferences",
			description: null,
			flag1: null,
			flag2: 10,
			status_id: 1,
			sort_id: 141,
			z_createdAt: "2023-09-29T17:33:04.025Z",
			z_updatedAt: "2023-09-29T17:33:04.025Z",
			z_comments: null,
			z_internal_notes: null,
			z_createdBy: 0,
			z_updatedBy: 0,
			format: null,
			createdAt: "2023-09-29T17:33:04.025Z",
			updatedAt: "2023-09-29T17:33:04.025Z",
			comments: null,
			internal_notes: null,
			createdby: 0,
			updatedby: 0,
			arrayCfgs: [
				{
					id: 23,
					type_id: 1,
					group_id: 100,
					code: "total_budget_per_year",
					name: "Baseline total budget",
					description: "Baseline total budget for each year of the baseline",
					flag1: null,
					flag2: 10,
					status_id: 1,
					sort_id: 23,
					z_createdAt: "2023-07-26T18:26:28.942Z",
					z_updatedAt: "2023-07-26T18:26:28.942Z",
					z_comments: null,
					z_internal_notes: null,
					z_createdBy: 0,
					z_updatedBy: 0,
					format: "currency",
					createdAt: "2023-07-26T18:26:28.942Z",
					updatedAt: "2023-07-26T18:26:28.942Z",
					comments: null,
					internal_notes: null,
					createdby: 0,
					updatedby: 0,
				},
				{
					id: 24,
					type_id: 1,
					group_id: 100,
					code: "max_budget_increase",
					name: "Maximum budget increase allowed",
					description: "Maximum budget increase allowed for each year",
					flag1: null,
					flag2: 10,
					status_id: 1,
					sort_id: 24,
					z_createdAt: "2023-07-26T18:28:49.785Z",
					z_updatedAt: "2023-07-26T18:28:49.785Z",
					z_comments: null,
					z_internal_notes: null,
					z_createdBy: 0,
					z_updatedBy: 0,
					format: "currency",
					createdAt: "2023-07-26T18:28:49.785Z",
					updatedAt: "2023-07-26T18:28:49.785Z",
					comments: null,
					internal_notes: null,
					createdby: 0,
					updatedby: 0,
				},
				{
					id: 25,
					type_id: 1,
					group_id: 100,
					code: "max_budget_decrease",
					name: "Maximum budget decrease allowed",
					description: "Maximum budget decrease allowed for each year ",
					flag1: null,
					flag2: 10,
					status_id: 1,
					sort_id: 26,
					z_createdAt: "2023-07-26T18:30:10.831Z",
					z_updatedAt: "2023-07-26T18:30:10.831Z",
					z_comments: null,
					z_internal_notes: null,
					z_createdBy: 0,
					z_updatedBy: 0,
					format: "currency",
					createdAt: "2023-07-26T18:30:10.831Z",
					updatedAt: "2023-07-26T18:30:10.831Z",
					comments: null,
					internal_notes: null,
					createdby: 0,
					updatedby: 0,
				},
			],
			items: [
				{
					id: 11689,
					baseline_id: 165,
					comp_type_id: 11,
					comp_value: "FY24",
					status_id: 1,
					sort_id: 1,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2025-07-18T16:50:11.686Z",
					createdBy: 1,
					updatedBy: 1,
					total_budget_per_year: "11",
					max_budget_increase: "21",
					max_budget_decrease: "31",
				},
				{
					id: 11690,
					baseline_id: 165,
					comp_type_id: 11,
					comp_value: "FY25",
					status_id: 1,
					sort_id: 2,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2025-12-17T18:26:57.142Z",
					createdBy: 1,
					updatedBy: 1,
					total_budget_per_year: "12",
					max_budget_increase: "22",
					max_budget_decrease: "32",
				},
				{
					id: 11691,
					baseline_id: 165,
					comp_type_id: 11,
					comp_value: "FY26",
					status_id: 1,
					sort_id: 3,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2025-07-18T16:50:11.686Z",
					createdBy: 1,
					updatedBy: 1,
					total_budget_per_year: "13",
					max_budget_increase: "23",
					max_budget_decrease: "33",
				},
				{
					id: 11692,
					baseline_id: 165,
					comp_type_id: 11,
					comp_value: "FY27",
					status_id: 1,
					sort_id: 4,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2025-07-11T20:55:21.999Z",
					createdBy: 1,
					updatedBy: 1,
					total_budget_per_year: "14",
					max_budget_increase: "24",
					max_budget_decrease: "34",
				},
				{
					id: 11693,
					baseline_id: 165,
					comp_type_id: 11,
					comp_value: "FY28",
					status_id: 1,
					sort_id: 5,
					photo: {
						type: "Buffer",
						data: [],
					},
					thumbnail: {
						type: "Buffer",
						data: [],
					},
					color: "null",
					createdAt: "2023-11-22T18:47:29.656Z",
					updatedAt: "2025-07-11T20:55:21.999Z",
					createdBy: 1,
					updatedBy: 1,
					total_budget_per_year: "15",
					max_budget_increase: "25",
					max_budget_decrease: "35",
				},
			],
		},
	};
	const initThisCfg2 = {
		id: 545,
		scenario_id: 43,
		comp_type_id: 611,
		comp_id: 11689,
		comp_value1: 7,
		comp_value2: "0",
		status_id: 1,
		sort_id: 19,
		photo: null,
		thumbnail: null,
		color: null,
		createdAt: "2025-04-11T13:06:34.824Z",
		updatedAt: "2025-04-28T16:50:38.462Z",
		createdBy: 1,
		updatedBy: 1,
		update_flag: 102,
	};

	const [thisCfg2, setThisCfg2] = useState(initThisCfg2);
	const [arrayItems2, setArrayItems2] = useState(initArrayItems2);

	const getArrayItems2 = (cfg) => {
		const cfgTypes = ["Near-term", "Long-term"];
		let arrayTemp = [];

		for (let idx = 1; idx <= 1; idx++) {
			if (typeof cfg[`comp_value${idx}`] !== "undefined") {
				arrayTemp.push({
					id: idx,
					comp_id: cfg.comp_id,
					value: cfg[`comp_value${idx}`],
				});
			}
		}
		arrayTemp.sort((x, y) => x.value - y.value);
		return arrayTemp;
	};

	const sliderChangeHandler2 = (items) => {
		items.map((x) => {
			thisCfg2[`comp_value${x.id}`] = x.value;
			thisCfg2.update_flag = 102;
			return false;
		});
		setThisCfg2({ ...thisCfg2 });
		setArrayItems2([...getArrayItems2({ ...thisCfg2 })]);

		debugLog(3, "[Test][ACTION] verticalSliderInputChangeHandler", {
			props: props2,
			items: items2,
			thisCfg: thisCfg2,
		});
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					Slider Testing
				</Text>
				<Box p="3rem">
					<VStack align="start" spacing="2">
						<Box>
							<Text>VerticalRangeSlider</Text>
							<VerticalRangeSlider
								key={1}
								items={arrayItems}
								range={props.range}
								step={props.step}
								mode={props.mode}
								// marks={true}
								extra={props.extra}
								onChange={sliderChangeHandler}
							/>
						</Box>
						<Box>
							<Text>VerticalSliderInput</Text>
							<VerticalSliderInput
								key={2}
								items={arrayItems2}
								range={props2.range}
								step={props2.step}
								mode={props2.mode}
								extra={props2.extra}
								onChange={sliderChangeHandler2}
								// onError={props2.onError}
								onError={() => void 0}
							/>
						</Box>
					</VStack>
				</Box>
			</Stack>
		</Box>
	);
};

const ExportTesting = () => {
	const [expenses, setExpenses] = useState([
		{
			id: "e0",
			title: "Car Insuracne",
			amount: 294.67,
			date: new Date(2023, 6, 1),
		},
		{
			id: "e1",
			title: "Toilet Paper",
			amount: 94.12,
			date: new Date(2020, 7, 14),
		},
		{
			id: "e2",
			title: "New TV",
			amount: 799.49,
			date: new Date(2021, 2, 12),
		},
		{
			id: "e3",
			title: "Car Insurance",
			amount: 294.67,
			date: new Date(2021, 2, 28),
		},
		{
			id: "e4",
			title: "New Desk (Wooden)",
			amount: 450,
			date: new Date(2021, 5, 12),
		},
	]);

	return (
		<>
			<Box p="3rem" borderBottom="1px solid black">
				<Stack>
					<Text textStyle="lg" fontWeight="semibold">
						Export Testing
					</Text>
					<Button onClick={() => exportJSON(expenses)}>Export JSON</Button>
					&nbsp;
					<Button onClick={() => exportSpreadsheet(expenses)}>Download As Excel</Button>
				</Stack>
			</Box>
		</>
	);
};

const ColorPickerTesting = () => {
	const [bgColor, setBgColor] = useState("#fff");
	const handleChangeComplete = (color) => {
		// this.setState({ background: color.hex });
		console.log(color);
		setBgColor(color.hex);
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					SketchPicker
				</Text>
				<SketchPicker
					color={bgColor}
					presetColors={[
						"#D0021B",
						"#F5A623",
						"#F8E71C",
						"#8B572A",
						"#7ED321",
						"#417505",
						"#BD10E0",
						"#9013FE",
						"#4A90E2",
						"#50E3C2",
						"#B8E986",
						"#000000",
						"#4A4A4A",
						"#9B9B9B",
						"#FFFFFF",
					]}
					onChangeComplete={handleChangeComplete}
				/>
				{/* <MaterialPicker color={bgColor} onChangeComplete={handleChangeComplete} />
						<SwatchesPicker color={bgColor} onChangeComplete={handleChangeComplete} />
						<BlockPicker color={bgColor} onChangeComplete={handleChangeComplete} /> */}
			</Stack>
		</Box>
	);
};

const ModalTesting = () => {
	const [modalOpen, setModalOpen] = React.useState(false);
	// const modalOpenHandler = (open) => {
	// 	setModalOpen(open);
	// };
	// const modalCloseHandler = () => {
	// 	setModalOpen(false);
	// };
	const handleModealOpen = (option) => {
		setModalOpen(option);
	};
	const testingHandler = () => {
		alert("(Test) Testing is clicked!");
	};

	return (
		<Box p="3rem" borderBottom="1px solid black">
			<Stack>
				<Text textStyle="lg" fontWeight="semibold">
					ModalBox
				</Text>
				<div>
					<Button onClick={() => handleModealOpen(true)}>Open modal</Button>
					{modalOpen && (
						<>
							<ModalBox
								title="Modal Testing"
								// onOpen={modalOpenHandler}
								// onClose={modalCloseHandler}
								onSetOpen={handleModealOpen}
								child={true}
								childButtonLabel="Open Child"
								childTitle="Child"
								childDescription="This is the content of the Child Modal"
								childWidth="300px"
								childHeight="200px"
							>
								<>
									<Box>
										<div>This is a testing</div>
										<Button onClick={testingHandler}>Testing</Button>
									</Box>
								</>
							</ModalBox>
						</>
					)}
				</div>
			</Stack>
		</Box>
	);
};

/*
	const MultiSelectTesting = () => {
		// const [selectedItems, setSelectedItems] = useState([10, 11, 33]);
		// let selectedItems = [10, 11, 33];
		const changeValueHandler = (selected) => {
			debugLog(3, "[Test][ACTION] multiSelectChangeValueHandler", { selected: selected });
		};

		return (
			<Box p="3rem" borderBottom="1px solid black">
				<Stack>
					<Text textStyle="lg" fontWeight="semibold">
						MultiSelect
					</Text>
					<MuiMultiSelect
						items={items}
						selectedItems={[10, 11, 33]}
						// selectedItems={[
						// 	{
						// 		id: 3,
						// 		name: "Voucher",
						// 		slug: "voucher",
						// 		type: "Main",
						// 		locale: "en",
						// 		created_at: "2021-11-15T08:27:23.000Z",
						// 		updated_at: "2021-11-15T08:27:23.000Z",
						// 		cover: null,
						// 	},
						// ]}
						// onChangeValue={() => {}}
						onChangeValue={changeValueHandler}
					/>
				</Stack>
			</Box>
		);
	};

	const MultiSelectChkboxTesting = () => {
		const { trackEvent } = useTracking();

		const changeChkboxHandler = (selected) => {
			debugLog(3, "[Test][ACTION] multiSelectCheckboxChangeHandler", { selected: selected });

			trackEvent({
				event: "Roles changed",
				props: { a: 1, b: 2, selected: selected },
			});
		};

		return (
			<Box p="3rem" borderBottom="1px solid black">
				<Stack>
					<Text textStyle="lg" fontWeight="semibold">
						MultiSelectChkbox
					</Text>
					<MuiMultiSelectChkbox items={items} selectedItems={[33]} onChangeValue={changeChkboxHandler} />
				</Stack>
			</Box>
		);
	};

	const MultiSelectAutocompleteTesting = () => {
		const changeAutocompleteHandler = (selected) => {
			debugLog(3, "[Test][ACTION] multiSelectAutocompleteChangeHandler", {
				selected: selected,
			});
		};

		return (
			<>
				<Box p="3rem" borderBottom="1px solid black">
					<Stack>
						<Text textStyle="lg" fontWeight="semibold">
							MultiSelectAutocomplete
						</Text>
						<MuiMultiSelectAutocomplete
							mode="edit"
							items={items}
							// selectedItems={[10, 11, 33]}
							selectedItems={[]}
							isOptionEqualToValue={(option, newValue) => {
								return option.id === newValue.id;
							}}
							onChangeValue={changeAutocompleteHandler}
						/>
					</Stack>
				</Box>
			</>
		);
	};
*/

const MultlSelectCoreTesting = () => {
	const options = [
		{ id: 1, label: "Admin" },
		{ id: 2, label: "Editor" },
		{ id: 3, label: "Viewer" },
	];
	const [selectedIds, setSelectedIds] = useState([2]);

	return (
		<>
			<Box p="3rem" borderBottom="1px solid black">
				<Stack>
					<Text textStyle="lg" fontWeight="semibold">
						MultiSelect - shared form helper
					</Text>
					<FormMultiSelect
						type={{ name: "Roles" }}
						items={options}
						selected={selectedIds}
						onUpdate={(selected) => {
							// e.g. persist ids: selectedObjects.map(o => o.id)
							setSelectedIds(getValuesByPropertyPath(selected, "id"));
						}}
					/>
				</Stack>
			</Box>
		</>
	);
};

const Test_Page = (props) => {
	const renderCount = useRef(0);
	renderCount.current++;

	const { trackEvent } = useTracking();
	const inputRef = useRef();
	const Input = forwardRef((props, ref) => <input ref={ref} {...props} />);

	const MyComponent = React.forwardRef((props, ref) => {
		return <Box ref={ref} {...props} />;
	});

	// Local State
	const [expenses, setExpenses] = useState([
		{
			id: "e0",
			title: "Car Insuracne",
			amount: 294.67,
			date: new Date(2023, 6, 1),
		},
		{
			id: "e1",
			title: "Toilet Paper",
			amount: 94.12,
			date: new Date(2020, 7, 14),
		},
		{
			id: "e2",
			title: "New TV",
			amount: 799.49,
			date: new Date(2021, 2, 12),
		},
		{
			id: "e3",
			title: "Car Insurance",
			amount: 294.67,
			date: new Date(2021, 2, 28),
		},
		{
			id: "e4",
			title: "New Desk (Wooden)",
			amount: 450,
			date: new Date(2021, 5, 12),
		},
	]);

	const { showDialog, withConfirmation, withError } = useDialogBox();

	// --- Effect: Test setTimeout
	useEffect(() => {
		const timeout = setTimeout(() => {
			debugLog(2, "[Test][FLOW] timeout callback fired", {});
		}, 10000);

		debugLog(2, "[Test][FLOW] setTimeout test started", {});
		return () => clearTimeout(timeout);
	}, []);

	// --- Effect: Test Dialog with Retry
	useEffect(() => {
		// examples to call Dialog with Retry
		// showDialog(
		// 	{
		// 		title: "Failed to load data",
		// 		message: "Network request failed. Would you like to retry?",
		// 		// type: "confirm",
		// 		type: "error", // comes with "Retry", if the retryCallback() is configured
		// 		callback: () => console.log("callback"), // will overwrite onConfirm
		// 		cancelCallback: () => console.log("cancelCallback"), // will overwrite onCancel
		// 		// retryCallback: () => console.log("retryCallback"),
		// 		okLabel: "My Okay",
		// 		confirmLabel: "My Confirm",
		// 		cancelLabel: "My Cancel",
		// 		closeLabel: "My Dismiss",
		// 		retryLabel: "My Try Again",
		// 	},
		// 	() => console.log("onConfirm"),
		// 	() => console.log("onCancel")
		// );
		// withError("Hello", () => alert("retry"));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// ================= Handlers
	const changePhotoHandler = async (item) => {
		// let imgData = "";
		let reader = new FileReader();
		// let file = e.target.files[0];
		reader.onloadend = (theFile) => {
			const imgData = {
				blob: theFile.target.result,
				name: item.name,
				// visitorId:  this.props.socketio.visitorId
			};

			console.log("imgData");
			console.log(imgData);
		};
		reader.readAsDataURL(item);

		const formData = new FormData();
		// Update the formData object
		// formData.append("file", item, item.name);
		formData.append("file", item);
		formData.append("tableName", "baseline_items");
		formData.append("columnName", "photo");
		formData.append("itemId", "62");
		formData.append("updatedAt", new Date());
		formData.append("updatedBy", Session().currUser.id);
		// formData.append("filename", item.name);

		try {
			await axios
				.post(`${process.env.REACT_APP_SERVER_URI}/api/upload/photo`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
					withCredentials: true,
				})
				.then((res) => {
					// then print response status
					console.log("upload photo...");
					console.log(res);
				});
		} catch (error) {
			errorLog(2, "[Test][FLOW] changePhotoHandler failed", { error: error });
			if (error.response.status === 413) {
				// setMsgBox({
				// 	title: "Error",
				// 	message: [
				// 		"Image size is too large.",
				// 		" ",
				// 		`Please reduce the image (i.e. <= ${error.response.data.fileSize}) and try again try again`,
				// 	],
				// 	type: "error",
				// });
				showDialog({
					title: "Error",
					message: [
						"Image size is too large.",
						" ",
						`Please reduce the image (i.e. <= ${error.response.data.fileSize}) and try again try again`,
					],
					type: "error",
				});
			}
		}

		debugLog(4, "[Test][PROCESS] changePhotoHandler readerLoaded", { item: item, reader: reader });
	};

	const testingHandler = () => {
		alert("(Test) Testing is clicked!");
	};

	const listChangeHandler = (item) => {
		console.log("Test - listChangeHandler()");
		console.log(item);
	};

	// const exportSpreadsheet = (data) => {
	// 	const worksheet = XLSX.utils.json_to_sheet(data);
	// 	const workbook = XLSX.utils.book_new();
	// 	XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
	// 	//let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
	// 	//XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
	// 	// XLSX.writeFile(workbook, "DataSheet.xlsx");
	// 	XLSX.writeFile(workbook, "DataSheet.csv", { forceQuotes: true });
	// };

	const quantityChangeHandler = (item) => {
		console.log("Test - quantityChangeHandler");
		console.log(item);
	};

	// --- Logging: Render and State Snapshots ---
	// debugLog(2, "\n↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓\n");
	debugLog(9, "[Test][FLOW] render", { renderCount: renderCount.current });

	return (
		<MetreaProvider>
			<PageHeader pageTitle="Test Page" />
			<Box className="pageContent">
				{/* {msgBox && (
					<MsgModal
						title={msgBox.title}
						message={msgBox.message}
						callback={msgBox.callback}
						{...(msgBox.type ? { type: msgBox.type } : {})}
						// {...(msgBox.showConfirm ? { showConfirm: true } : {})}
						onConfirm={messageHandler}
						onCancel={msgBox.cancel}
					/>
				)} */}
				{/* {msgBox && (
					<MsgModal
						title={msgBox.title}
						message={msgBox.message}
						type={msgBox.type}
						callback={msgBox.callback}
						onCancel={msgBox.cancel}
					/>
				)} */}

				<SliderTesting />

				<MetreaUIv2Steps />

				<MetreaUiTesting />

				<EmailSender />

				<PrintToPdfTesting1 />

				<PrintToPdfTesting2 />

				<ExportTesting />

				<Box p="3rem" borderBottom="1px solid black">
					<Stack>
						<Text textStyle="lg" fontWeight="semibold">
							SortableList
						</Text>
						<SortableList items={items2} item={{ id: 2 }} onChange={listChangeHandler} />
					</Stack>
				</Box>

				<ColorPickerTesting />

				<ModalTesting />

				<MultlSelectCoreTesting />

				{/* <MultiSelectTesting /> */}

				{/* <MultiSelectChkboxTesting /> */}

				{/* <MultiSelectAutocompleteTesting /> */}

				<Box p="3rem" borderBottom="1px solid black">
					<Stack>
						<Text textStyle="lg" fontWeight="semibold">
							ForwardRef Testing
						</Text>

						<Input
							ref={inputRef}
							placeholder="Type here"
							style={{ border: "1px solid #ccc", margin: "3px" }}
						/>
						<Button onClick={() => inputRef.current.focus()}>Focus Input</Button>
						<br />
						<Text textStyle="md" fontWeight="medium">
							asChild Testing
						</Text>
						<MyComponent as="button" />
						<button aschild="true" onClick={testingHandler}>
							<MyComponent> Click me </MyComponent>
						</button>
					</Stack>
				</Box>

				{/* Counter */}
				<Box p="3rem" borderBottom="1px solid black">
					<Stack>
						<Text textStyle="lg" fontWeight="semibold">
							Counter
						</Text>
						<Counter />
					</Stack>
				</Box>

				<PageFooter />
			</Box>
		</MetreaProvider>
	);
};

// By wrapping the functional component in this track function
// we get the value of "page" along with every track called in About
// Note: These are the same arguments as using a decorator for class components
//  From NYT: although this is obviously awkward and the decorator syntax is recommended.
export const Test = track(
	{ page: "Test" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(Test_Page);

// export { Test };
